import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<circle cx="13" cy="11" r="2"/><path d="M28,5H8A2.0059,2.0059,0,0,0,6,7v3H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H23a2.0059,2.0059,0,0,0,2-2V24h3a2.0059,2.0059,0,0,0,2-2V7A2.0059,2.0059,0,0,0,28,5ZM23,26H4V12H6V22a2.0059,2.0059,0,0,0,2,2H23Zm5-4H12.4141L18,16.4141l3.293,3.2929a1,1,0,0,0,1.414-1.414L22.4141,18,25,15.4141l3,3Zm0-6.4141L25.707,13.293a.9994.9994,0,0,0-1.414,0L21,16.5859,18.707,14.293a.9994.9994,0,0,0-1.414,0L9.5859,22H8V7H28Z"/>';
export var PhotosOutlineSVG = function PhotosOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PhotosOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PhotosOutlineSVG);